<script setup lang="ts">
import type { ContentImageCollection } from '~/models/Content/ContentImageCollection'
import { computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { ContentType } from '~/models/Content/ContentType'
import useContentApi from '~/api/contentApi'
import ImageCollection from '~/components/article/ImageCollection.vue'

const { locationId } = defineProps<{
  locationId: number
  // Props from AU1, not used in AU2
  title?: string
  mode?: string
  images?: unknown[]
}>()

const { findContents } = useContentApi()

const { data } = useQuery({
  enabled: locationId > 0,
  queryKey: computed(() => ['image-collection', locationId]),
  queryFn: () => findContents<ContentImageCollection>({
    locationIdCriterion: [locationId],
    contentTypeCriterion: [ContentType.ImageCollection],
  }, 1).then(([data]) => data),
  staleTime: Infinity,
  retry: 1,
})
</script>

<template>
  <div
    v-if="data"
    class="au-image-collection-embed my-8"
  >
    <ImageCollection :content="data" embedded />
  </div>
</template>
